"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PIN_LOCKED_UNTIL_RESET = exports.PIN_LOCKED = exports.PIN_LOCKOUTS_PER_DAY = exports.PIN_LOCK_MINUTES = exports.PIN_ATTEMPTS = exports.SALESMAN_SESSION_DAYS = exports.SALESMAN_INVITE_HOURS = void 0;
/** How long an invite link works. */
exports.SALESMAN_INVITE_HOURS = 72;
exports.SALESMAN_SESSION_DAYS = 30;
/** Wrong PINs in a row before sign-in is refused for PIN_LOCK_MINUTES. */
exports.PIN_ATTEMPTS = 5;
exports.PIN_LOCK_MINUTES = 15;
/** Lockouts within a day after which only the owner resetting the PIN lets him in again. */
exports.PIN_LOCKOUTS_PER_DAY = 3;
/** 403 codes of a salesman sign-in: locked for a while (`until`), or until the owner resets. */
exports.PIN_LOCKED = 'PIN_LOCKED';
exports.PIN_LOCKED_UNTIL_RESET = 'PIN_LOCKED_UNTIL_RESET';
//# sourceMappingURL=salesman.js.map